// src/components/Projects/Kaboom/index.tsx
import React from 'react';
import Container from 'react-bootstrap/Container';

const Kaboom: React.FC = () => {
    return (
        <Container>
            <h3>Kaboom! (deprecated)</h3>
            <p>Experimenting with <a href="https://replit.com/">Replit</a> IDE + hosting and the <a href="https://kaboomjs.com/">Kaboom</a> JS library. See hosted site at <a href="https://kaboom.evanwchen.repl.co/">https://kaboom.evanwchen.repl.co/</a>.</p>
            <div className="container-iframe">
                <iframe 
                    src="https://kaboom.evanwchen.repl.co/"
                    className="responsive-iframe"
                    title="Kaboom game"
                />
            </div>
        </Container>
    );
};

export default Kaboom;

